module.exports = __webpack_public_path__ + "static/media/ieee-logo-bih-white.732b0089.png";